export enum DeviceActionTypes {
    API_RESPONSE_SUCCESS = '@@device/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@device/API_RESPONSE_ERROR',
    ADD_DEVICE = '@@device/ADD_DEVICE',
    UPDATE_DEVICE ='@@device/UPDATE_DEVICE',
    DELETE_DEVICE = '@@device/DELETE_DEVICE',
    GET_DEVICES = '@@device/GET_DEVICE',
    GET_DEVICE_TYPES = '@@device/GET_DEVICE_TYPES',
}